const menuPl = {
    "add_to_cart": "Dodaj do koszyka",
    "add_to_order": "Dodaj do zamówienia",
    "already_in_cart": "Już w Twoim koszyku",
    "update_order_item": "Aktualizuj zamówienie",
    "delete_order_item": "Usuń element",
    "available_categories": "Kategorie menu",
    "search_menu_placeholder": "Szukaj w menu",
    "guides": {
        "scan_qr": "Zeskanuj telefonem kod QR znajdujący się na stole",
        "order": "Zamów wybrane pozycje ze swojego telefonu",
        "pay": "Zapłać osobno lub od razu za pomocą telefonu",
        "accept": "Kontynuować"
    },
    "index_image": "Obraz indeksowy",
    "menu_saved": "Menu zapisane",
    "new_category": "Nowa kategoria",
    "menu_editor": "Menu edytora",
    "new_item": "Nowy przedmiot",
    "menu": "Menu",
    "allergens": "Alergeny",
    "generate_qr": "Wygeneruj kod QR",
    "allergen_list": {
        "gluten": "Gluten",
        "crustaceans": "Skorupiaki",
        "eggs": "Jajka",
        "fish": "Ryba",
        "peanuts": "Orzeszki ziemne",
        "soybeans": "Soja",
        "milk": "Mleko",
        "nuts": "Orzechy",
        "celery": "Seler",
        "mustard": "Musztarda",
        "sesame": "Sezam",
        "sulphur_dioxide": "Dwutlenek siarki",
        "lupin": "Łubin",
        "molluscs": "Mięczaki",
        "vegan": "Wegański"
    },
    "add_allergen": "Dodaj alergen",
    "auto_translate": "Tłumaczenie menu",
    "no_category_name": "Nie określono nazwy kategorii w bieżącym języku",
    "no_item_name": "Nie określono nazwy elementu w bieżącym języku",
    "category_and_items_language": "Język kategorii i elementów",
    "auto_translate_title": "Automatyczne tłumaczenie menu można zastosować tylko do kategorii i pozycji, które zostały już zapisane. Zaleca się podanie języka początkowego.",
    "auto_translate_description": "Ta funkcja korzysta z Tłumacza Google. Tłumaczenia nie zawsze są dokładne, dlatego warto je sprawdzić.",
    "translate_from": "Przetłumacz z",
    "translate_to": "Do tych języków",
    "auto_translate_error_invalid_languages": "Wybrano nieprawidłowe języki do tłumaczenia",
    "auto_translate_success": "Menu pomyślnie przetłumaczone",
    "auto_translate_error_permission": "Nie masz uprawnień do tłumaczenia menu",
    "auto_translate_error_generic": "Podczas tłumaczenia wystąpił nieznany błąd",
    "auto_translate_feature_not_available": "Automatyczne tłumaczenie menu jest dostępne wyłącznie w ramach subskrypcji PRO.",
    "change_subscription_plan": "Zmień plan subskrypcji",
    "menu_headers": "Nagłówki i stopki menu",
    "menu_header_editor_title": "Nagłówki i stopki menu to teksty wyświetlane na górze i dole menu online, które możesz dowolnie określić.",
    "menu_header_feature_not_available": "Edycja nagłówka i stopki menu jest dostępna wyłącznie w ramach subskrypcji PRO.",
    "menu_header": "Nagłówek menu",
    "menu_header_placeholder": "Napisz krótką wiadomość powitalną lub podkreśl aktualną ofertę",
    "menu_footer": "Stopka menu",
    "menu_footer_placeholder": "Możesz wprowadzić informacje o opłatach za usługi, alergenach lub inne ważne informacje",
    "menu_header_save_success": "Nagłówek i stopka menu zostały pomyślnie zapisane",
    "menu_header_save_error": "Wystąpił błąd podczas zapisywania nagłówka i stopki menu",
    "menu_header_permission_error": "Nie masz uprawnień do edycji nagłówka i stopki menu, aby edytować stopkę",
    "menu_header_generic_error": "Wystąpił nieznany błąd podczas ładowania nagłówka i stopki menu",
    "menu_import": "Import menu",
    "import_success": "Ostatni import został pomyślnie ukończony",
    "import_failed": "Ostatni import nie powiódł się z powodu eksportu po stronie serwera",
    "attached_document": "Załączony dokument",
    "allowed_file_types": "Dozwolone typy plików: .doc, .docx, .pdf, .txt, .html",
    "import_language_helpertext": "Język dokumentu",
    "import_options_pro_helpertext": "Opcje „Dezaktywuj” i „Dodaj” są dostępne wyłącznie w ramach subskrypcji PRO.",
    "import_option_helpertexts": {
        "replace": "Bieżące kategorie i pozycje menu zostaną usunięte i zastąpione nowo wygenerowanym menu.",
        "deactivate": "Obecne kategorie i pozycje menu zostaną dezaktywowane, a na ich miejsce zostanie dodane nowe menu.",
        "add": "Obecne menu pozostanie aktywne, a nowe pozycje menu zostaną dodane za bieżącym menu."
    },
    "import_type": "Typ importu",
    "import_options": {
        "replace": "Zastępować",
        "deactivate": "Dezaktywować",
        "add": "Dodać"
    },
    "menu_import_tooltip": "Prześlij plik z menu swojej restauracji lub podaj link do strony internetowej zawierającej menu. W obu przypadkach upewnij się, że menu jest dostępne w dokumencie w wersji tekstowej, ponieważ nie możemy przetwarzać obrazów. Po rozpoczęciu importu nasza sztuczna inteligencja automatycznie przetworzy plik i utworzy nowe menu w wybranym języku. Jeśli chcesz później przetłumaczyć pozycje na wiele języków, skorzystaj z funkcji „Tłumaczenie menu”! Proces importowania trwa 5–10 minut.",
    "menu_import_replace_warning": "Wybrana metoda importu usunie bieżące menu i zastąpi je nowym. Upewnij się, że przesłany plik ma poprawny format i zawartość, ponieważ operacja jest nieodwracalna! Jeśli nie chcesz usuwać bieżącego menu, wybierz inną metodę importu.",
    "start_import": "Import",
    "file_or_url_required": "Proszę wybrać plik lub podać adres URL witryny",
    "file_and_url_error": "Możesz podać tylko plik lub adres URL, nie oba jednocześnie",
    "import_site_url": "Adres URL witryny",
    "import_in_progress": "Import w toku",
    "import_duration": "Może to potrwać kilka minut",
    "listing_manager_info": {
        "summary": "Dzięki Mozrest możesz łatwo zarządzać swoimi ofertami i recenzjami z jednej platformy. Oszczędzaj czas, popraw swoją reputację online i zwiększ wydajność operacyjną.",
        "bullet_1": "Błyskawicznie aktualizuj swoje oferty w serwisach Tripadvisor, Apple Maps, Google, Facebook, Quandoo i Bing za pomocą jednego kliknięcia.",
        "bullet_2": "Otrzymuj powiadomienia w czasie rzeczywistym, gdy Twoje godziny otwarcia i dostępność nie pasują, zapobiegając w ten sposób rozczarowaniu gości i negatywnym recenzjom.",
        "bullet_3": "Sprawdź szybko, czy Twój wpis jest kompletny i upewnij się, że wszystkie ważne szczegóły, takie jak zdjęcia, menu i godziny otwarcia, są dokładne i aktualne.",
        "setup_button": "Skonfiguruj Mozrest",
        "pro_warning": "Ta funkcja wymaga subskrypcji PRO."
    },
    "listing_manager_tabs": {
        "Listing": "Wymienianie kolejno",
        "ListingAnalytics": "Analityka ofert",
        "ReviewsPage": "Recenzje",
        "ReviewAnalytics": "Przegląd analityki",
        "ReplyTemplates": "Szablony odpowiedzi",
        "Notifications": "Powiadomienia"
    },
    "review_manager_set_title": "Skonfiguruj menedżera recenzji",
    "review_manager_set_description": "Podaj nam kilka informacji o swojej firmie, abyśmy mogli utworzyć Twoje podstawowe ustawienia",
    "confirm_settings": "Potwierdź ustawienia",
    "confirm_delete_item": "Usunąć element?",
    "confirm_delete_category": "Usunąć kategorię i wszystkie jej elementy?",
    "reorder_disabled_search": "Zmiana kolejności jest wyłączona podczas wyszukiwania",
};

export default menuPl;
